import { __cBlogService } from '@/services/client/__c.blog.service'
import { formatWordPressPostsToArticles } from '@/services/formatter/__f.blog'
import { TArticle } from '@/types/blog'
import { useQuery } from '@tanstack/react-query'

export const useWordPressPostsQuery = (
  categoryId: number,
  perPage: number = 12,
  enabled?: boolean
) => {
  return useQuery<TArticle[]>({
    queryKey: ['wordpress-posts', categoryId, perPage],
    queryFn: async () => {
      const posts = await __cBlogService.getWordPressPosts({
        categories: categoryId,
        per_page: perPage,
      })
      return formatWordPressPostsToArticles(posts, categoryId)
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
}

